import moment from 'moment';

export default {
  methods: {
    getDotNotation(path, obj) {
        return path.split(".").reduce((o, i) => o?.[i] ?? "", obj);
      },
    formaters(type, emptyCase = "") {
      return {
        moneda: (v, { decimales = 2, remplaso = "" }) =>
          v !== "" ? this.$formatter(v, 1, remplaso, decimales) : emptyCase,
        number: (v) => (v !== "" ? this.$formatter(v, 0, ".00") : emptyCase),
        numero: (v, { decimales = 2, remplaso = ".00" }) =>
          v !== "" ? this.$formatter(v, 0, remplaso, decimales) : emptyCase,
        fecha: (v, { formato }) =>
          v ? moment(v, "YYYY-MM-DD").format(formato) : emptyCase,
        price: (v) => (v !== "" ? this.$formatter(v, 1) : emptyCase),
        undefined: (s) => (s ? s : emptyCase),
      }[type];
    },
  },
};
